"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _productList = require("./productList");

var _productList2 = _interopRequireDefault(_productList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _productList2.default;